<div id="dsw" style="min-height: auto; padding-bottom: 0">
    <div class="popup-overlay"></div>
    <div class="cst-popup ">
      <div class="popup-header">
        <div class="flex-center space-between">
          <h2 translate>lblInformation</h2>
          <em class="fas fa-times close-icn-popup popup-close" (click)="activeModal.close(false)"></em>
        </div>
      </div>
      <div class="popup-content">
        <div class="clearfix">
            <label translate>lblMessageForConfirmRegMobileNo</label>
          </div>
          <div class="row">
            <div class="col-100">
              <div class="btn-grp fright xsmbt10">
                <button translate class="btn smallbtn fleft" aria-label="Center Align" id="showRegPhoneNumber"
                   (click)="onConfirm()" type="submit">
                  lblOk
                </button>
              </div>
            </div>
          </div>
    </div>
  </div>
